var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"get-data-func":_vm.getTeachers,"headers":_vm.headers,"filter-items":_vm.filterItems,"must-sort":false,"clickable":"","item-key":"code","search-text":"搜索姓名","title-text":"教职工列表"},on:{"click:row":function($event){return _vm.goDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }